(function (process){
var rtc = require('rtc-tools');
var debug = rtc.logger('rtc-quickconnect');
var cleanup = require('rtc-tools/cleanup');
var getable = require('cog/getable');

module.exports = function(signaller, opts) {
  var calls = getable({});
  var getPeerData = require('./getpeerdata')(signaller.peers);
  var heartbeats = require('./heartbeat')(signaller, opts);

  function create(id, pc) {
    var heartbeat = heartbeats.create(id);
    var call = {
      active: false,
      signalling: false,
      pc: pc,
      channels: getable({}),
      streams: [],
      lastping: Date.now(),
      heartbeat: heartbeat
    };
    calls.set(id, call);

    // Detect changes to the communication with this peer via
    // the signaller
    heartbeat.on('signalling:state', function(connected) {
      call.signalling = connected;
    });

    // Indicate the call creation
    signaller('call:created', id, pc);
    return call;
  }

  function createStreamAddHandler(id) {
    return function(evt) {
      debug('peer ' + id + ' added stream');
      updateRemoteStreams(id);
      receiveRemoteStream(id)(evt.stream);
    };
  }

  function createStreamRemoveHandler(id) {
    return function(evt) {
      debug('peer ' + id + ' removed stream');
      updateRemoteStreams(id);
      signaller('stream:removed', id, evt.stream);
    };
  }

  function end(id) {
    var call = calls.get(id);

    // if we have no data, then do nothing
    if (! call) {
      return;
    }

    // Stop the heartbeat
    if (call.heartbeat) {
      call.heartbeat.stop();
    }

    // If a monitor is attached, remove all listeners
    if (call.monitor) {
      call.monitor.clear();
    }

    // if we have no data, then return
    call.channels.keys().forEach(function(label) {
      var channel = call.channels.get(label);
      var args = [id, channel, label];

      // emit the plain channel:closed event
      signaller.apply(signaller, ['channel:closed'].concat(args));

      // emit the labelled version of the event
      signaller.apply(signaller, ['channel:closed:' + label].concat(args));

      // decouple the events
      channel.onopen = null;
    });

    // trigger stream:removed events for each of the remotestreams in the pc
    call.streams.forEach(function(stream) {
      signaller('stream:removed', id, stream);
    });

    // delete the call data
    calls.delete(id);

    // trigger the call:ended event
    signaller('call:ended', id, call.pc);

    // ensure the peer connection is properly cleaned up
    cleanup(call.pc);
  }

  function ping(sender) {
    var call = calls.get(sender && sender.id);

    // set the last ping for the data
    if (call) {
      call.lastping = Date.now();
      call.heartbeat.touch();
    }
  }

  function receiveRemoteStream(id) {
    return function(stream) {
      signaller('stream:added', id, stream, getPeerData(id));
    };
  }

  function start(id, pc, data) {
    var call = calls.get(id);
    var streams = [].concat(pc.getRemoteStreams());

    // flag the call as active
    call.active = true;
    call.streams = [].concat(pc.getRemoteStreams());

    pc.onaddstream = createStreamAddHandler(id);
    pc.onremovestream = createStreamRemoveHandler(id);

    debug(signaller.id + ' - ' + id + ' call start: ' + streams.length + ' streams');
    signaller('call:started', id, pc, data);

    // configure the heartbeat timer
    call.lastping = Date.now();

    // Monitor the heartbeat for signaller disconnection
    call.heartbeat.once('disconnected', function() {
      signaller('call:expired', id, call.pc);
      return end(id);
    });

    // examine the existing remote streams after a short delay
    process.nextTick(function() {
      // iterate through any remote streams
      streams.forEach(receiveRemoteStream(id));
    });
  }

  function updateRemoteStreams(id) {
    var call = calls.get(id);

    if (call && call.pc) {
      call.streams = [].concat(call.pc.getRemoteStreams());
    }
  }

  calls.create = create;
  calls.end = end;
  calls.ping = ping;
  calls.start = start;

  return calls;
};

}).call(this,require('_process'))
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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